// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23jHB","fullView":"styles_fullView__wLblF"};